import React  from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";


function Expertise () {

    return(

        <>

        <Header/>

         {/*===== HERO AREA START =====*/}
  <div
    className="inner-hero"
    style={{ backgroundImage: "url(assets/img/bg/Ashok.jpg)" }}
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-8 m-auto text-center">
          <div className="inner-main-heading">
            <h1>Expertise</h1>
            <div className="breadcrumbs-pages">
              {/* <ul>
                <li>
                  <a href="index.html">Home</a>
                </li>
                <li className="angle">
                  <i className="fa-solid fa-angle-right" />
                </li>
                <li>Expertise</li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/*===== HERO AREA START =====*/}






        {/*==== SERVICE AREA START =====*/}



                <div className="service10 sp">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 m-auto text-center">
                                <div className="heading10">
                                    <span
                                        className="sub-title"
                                        data-aos="zoom-in-left"
                                        data-aos-duration={900}
                                    >
                                        {/* <img src="assets/img/icons/span10.svg" alt="" /> Expertise */}

                                    </span>
                                   
                                </div>
                            </div>
                        </div>
                        <div className="row mt-20">
                            <div
                                className="col-lg-4 col-md-6"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                ata-aos-delay={200}
                            >
                                <div className="service10-box mt-60">
                                    <div className="image">
                                        <img src="assets/img/service/" alt="" />
                                    </div>
                                    <div className="content heading10">
                                        <h4>
                                            <a href="service-details1.html">Community Mobilization</a>
                                        </h4>
                                        <p className="mt-16">

Since 1982, I have worked with diverse communities, focusing on empowerment, rights, and meaningful change. My decades of experience reflect a strong commitment to improving lives and strengthening communities.
                                        </p>
                                        {/* <a className="learn2" href="service-details1.html">
                                            <span className="arrow-all">
                                                <span className="arrow1">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                                <span className="arrow2">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-4 col-md-6"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                ata-aos-delay={500}
                            >
                                <div className="service10-box mt-60">
                                    <div className="image">
                                        <img src="assets/img/service/" alt="" />
                                    </div>
                                    <div className="content heading10">
                                        <h4>
                                            <a href="service-details1.html">Urban Solid Waste Management</a>
                                        </h4>
                                        <p className="mt-16">
                                          Between 1998 and 2001, I led a pioneering solid waste management model in Bhubaneswar, later replicated in Paradeep, Berhampur, and adopted by corporate sectors in Angul and Damanjodi. My work received State Government recognition for innovation and leadership in urban waste management.
                                        </p>
                                        <a className="learn2" href="service-details1.html">
                                            {/* <span className="arrow-all">
                                                <span className="arrow1">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                                <span className="arrow2">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                            </span> */}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-4 col-md-6"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                ata-aos-delay={300}
                            >
                                <div className="service10-box mt-60">
                                    <div className="image">
                                        <img src="assets/img/service/" alt="" />
                                    </div>
                                    <div className="content heading10">
                                        <h4>
                                            <a href="service-details1.html">Biomedical Waste Management</a>
                                        </h4>
                                        <p className="mt-16">
                                            Entering a new market? competitive analysis, positioning
                                            strategies, and go-to-market plans that.
                                        </p>
                                        <a className="learn2" href="service-details1.html">
                                            {/* <span className="arrow-all">
                                                <span className="arrow1">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                                <span className="arrow2">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                            </span> */}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-4 col-md-6"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                ata-aos-delay={400}
                            >
                                <div className="service10-box mt-60">
                                    <div className="image">
                                        <img src="assets/img/service/service10.png" alt="" />
                                    </div>
                                    <div className="content heading10">
                                        <h4>
                                            <a href="service-details1.html">Growth Catalyst Program</a>
                                        </h4>
                                        <p className="mt-16">
                                            Our framework focuses on identifying an growth barriers and
                                            implementing best of effective strategies to overcome them.{" "}
                                        </p>
                                        <a className="learn2" href="service-details1.html">
                                            {/* <span className="arrow-all">
                                                <span className="arrow1">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                                <span className="arrow2">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                            </span> */}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-4 col-md-6"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                ata-aos-delay={300}
                            >
                                <div className="service10-box mt-60">
                                    <div className="image">
                                        <img src="assets/img/service/service.png" alt="" />
                                    </div>
                                    <div className="content heading10">
                                        <h4>
                                            <a href="service-details1.html">Business Boost Framework</a>
                                        </h4>
                                        <p className="mt-16">
                                            We help you create a strong brand identity that resonates with
                                            your audiences. From logo design to brand voice development.
                                        </p>
                                        <a className="learn2" href="service-details1.html">
                                            {/* <span className="arrow-all">
                                                <span className="arrow1">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                                <span className="arrow2">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                            </span> */}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-4 col-md-6"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                ata-aos-delay={300}
                            >
                                <div className="service10-box mt-60">
                                    <div className="image">
                                        <img src="assets/img/service/service10-.png" alt="" />
                                    </div>
                                    <div className="content heading10">
                                        <h4>
                                            <a href="service-details1.html">The Creative Foundry</a>
                                        </h4>
                                        <p className="mt-16">
                                            We transform your startup’s vision into stunning designs and
                                            compelling content Whether it for web, on your social media.
                                        </p>
                                        <a className="learn2" href="service-details1.html">
                                            {/* <span className="arrow-all">
                                                <span className="arrow1">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                                <span className="arrow2">
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                            </span> */}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*==== SERVICE AREA END =====*/}


                <Footer/>
        
        </>
    )
}

export default Expertise;